/* Angular imports **/
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { QRCodeModule } from 'angular2-qrcode';
import { MnFullpageModule } from 'ngx-fullpage';
import { AccordionModule } from 'ngx-accordion';
import { Http, HttpModule } from '@angular/http';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { RouterModule, Routes } from '@angular/router';
import { YoutubePlayerModule } from 'ng2-youtube-player';
import { CookieService, CookieModule } from 'ngx-cookie';
import { HTTP_INTERCEPTOR_PROVIDER } from 'ng2-http-interceptor';
import { LoadingBarModule, LoadingBarService } from 'id-loading-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';


/* Modules **/
import { StoreModule } from './store/store.module';
import { UserModule } from './user/user.module';
import { ModulesModule } from './modules/modules.module';


/* Providers **/
import { environment } from './environment';
import { RoutingModule } from './app.routes';
import { MainPipeModule } from './app.pipes';
import { InterceptedHttp } from './app.interceptor';
import { ImageSizeDirective } from './store/store.imagesize.directive';
import { ImageZoomModule } from 'angular2-image-zoom';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';


/* Declarations **/
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './404.component';

import { FAQComponent } from './faq/faq.component';
import { InfoComponent } from './info/info.component';
import { GiftComponent } from './gift/gift.component';
import { TermsComponent } from './terms/terms.component';
import { MediaComponent } from './media/media.component';
import { ViewerComponent } from './viewer/viewer.component';
import { PrivacyComponent } from './terms/privacy.component';
import { UpdatesComponent } from './updates/updates.component';
import { TrackerComponent } from './tracker/tracker.component';
import { LogoutComponent } from './user/logout/logout.component';
import { HomeFeatureComponent } from './home/features/feature.component';
import { CrimeComponent } from './info/info.crime.component';
import { PrisonLifeComponent } from './info/info.prison-life.component';
import { CorporationsComponent } from './info/info.corporations.component';
import { ActivationComponent } from './user/user-activate/activate.component';
import { RecoveryComponent } from './user/user-recovery/recovery.component';
import { MenuFriendsComponent } from './user/community/menus/menu.friends.component';
import { MiniSignupComponent } from './user/create/mini/mini.signup.component';
import { LoginComponent } from './user/login/login.component';

// Helpers
import 'ts-helpers';
import 'hammerjs';

@NgModule({
  bootstrap: [
    AppComponent
  ],
  providers: [
    HttpModule,
    CookieService,
    InterceptedHttp,
    HTTP_INTERCEPTOR_PROVIDER
  ],
  imports: [
    UserModule,
    HttpModule,
    StoreModule,
    BrowserModule,
    FormsModule,
    MomentModule,
    QRCodeModule,
    ModulesModule,
    MainPipeModule,
    ReCaptchaModule,
    AccordionModule,
    ImageZoomModule,
    LoadingBarModule,
    YoutubePlayerModule,
    CookieModule.forRoot(),
    BrowserAnimationsModule,
    MnFullpageModule.forRoot(),
    MalihuScrollbarModule.forRoot(),
    Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ]),
    RoutingModule,
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    PageNotFoundComponent,
    LoginComponent,
    InfoComponent,
    FAQComponent,
    GiftComponent,
    TermsComponent,
    ViewerComponent,
    UpdatesComponent,
    MenuFriendsComponent,
    RecoveryComponent,
    ActivationComponent,
    CorporationsComponent,
    CrimeComponent,
    PrisonLifeComponent,
    HomeFeatureComponent,
    MiniSignupComponent,
    ImageSizeDirective,
    TrackerComponent,
    PrivacyComponent,
    LogoutComponent,
    MediaComponent
  ],
  exports: [
    LoginComponent,
    RouterModule
  ]
})

export class AppModule {
  constructor() {
  }
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/app.module.ts